import { useContext, useState } from 'react';
import {
  AuthContainer,
  LoadingSpinner,
  getAuthProviderName,
} from '@rabbit/elements/shared-components';
import FormCompleteProfile from '../templates/CompleteProfile/FormCompleteProfile';
import { useMyConsumerPersona } from '@rabbit/data/portal';
import { UserContext } from '../context/UserContext';

export function CompleteProfileView() {
  const contextValues = useContext(UserContext);
  const consumerPersona = useMyConsumerPersona();
  const consumerPersonaId = consumerPersona?.personaId;
  const consumerPersonaData = consumerPersona?.data?.consumer_private;
  const [isLoading, setIsLoading] = useState(false);
  const user = contextValues?.user;

  if (!consumerPersonaData || !consumerPersonaId) {
    // Wrap spinner in z-[1000] container to ensure visibility above navbar
    return (
      <div className="bg-canvas absolute top-0 left-0 z-[1000] flex h-[100vh] w-[100vw] items-center justify-center">
        <LoadingSpinner size="xl" />
      </div>
    );
  }

  const providerId =
    user?.providerId || user?.auth?.currentUser?.providerData?.[0]?.providerId;

  return (
    <div className="bg-canvas absolute top-0 left-0 z-[1000] flex h-[100vh] w-[100vw]">
      <AuthContainer title="Finish account" loading={isLoading}>
        <FormCompleteProfile
          id={consumerPersonaId}
          data={consumerPersonaData}
          authProvider={getAuthProviderName(providerId)}
          setIsLoading={setIsLoading}
        />
      </AuthContainer>
    </div>
  );
}

export default CompleteProfileView;